module.exports = __webpack_public_path__ + "static/images/step3.dc2efad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step/step3.png
// module id = 3nu5
// module chunks = 1